import { render } from "./aboutContent.vue?vue&type=template&id=76ce755a&scoped=true"
import script from "./aboutContent.vue?vue&type=script&lang=js"
export * from "./aboutContent.vue?vue&type=script&lang=js"

import "./aboutContent.vue?vue&type=style&index=0&id=76ce755a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-76ce755a"

export default script